export const sumProcedurePrices = (procedures: { price?: number }[]): number => {
  return procedures.reduce((total, procedure) => total + (procedure.price ?? 0), 0);
};

export const sumProcedureOriginalPrices = (procedures: { originalPrice?: number }[]): number => {
  return procedures.reduce((total, procedure) => total + (procedure.originalPrice ?? 0), 0);
};

export const hasProceduresPromotion = (procedures: { price?: number; originalPrice?: number }[]): boolean => {
  const [first] = procedures;
  return Boolean(first && first.originalPrice && first.price != null && first.price < first.originalPrice);
};
